import './App.css';
import ChatMannager from './Components/Main';
function App() {
  return (
    <div>
      <div>
        <ChatMannager />
      </div>
    </div>
  );
}
export default App;
